import { apiHelper } from './api_helper';

export const EMAIL_ENDPOINT = 'email-filedinhkem-chitiet';
export const emailFileDinhKemChiTietApi = {
    Insert: (datasend) => apiHelper.post(EMAIL_ENDPOINT, datasend),
    Update: (data) => apiHelper.put(EMAIL_ENDPOINT, data),
    Delete: (id) => apiHelper.delete(`${EMAIL_ENDPOINT}/${id}`),
    SelectByMailId: (ts_email_id) => apiHelper.get(`${EMAIL_ENDPOINT}/ts_email_id/${ts_email_id}`),
    SelectByMauThuId: (ex_mauthu_ketqua_id) => apiHelper.get(`${EMAIL_ENDPOINT}/ex_mauthu_ketqua_id/${ex_mauthu_ketqua_id}`),
    DeleteChiTiet: (id) => apiHelper.delete(`${EMAIL_ENDPOINT}/${id}`),

}